import axios from 'axios'


axios.defaults.baseURL = 'https://api.dantaxiforsikring.dk'
// axios.defaults.baseURL = 'http://127.0.0.1:8000'

export default {
	install(Vue) {
		const requestInterceptor = (config) => {
			const token = localStorage.getItem('token')
			if (token) {
				config.headers.Authorization = `Bearer ${token}`
			}
			return config
		}
		axios.interceptors.request.use(requestInterceptor, err => Promise.reject(err))
		Vue.prototype.$http = axios
	}
}